module.exports = __webpack_public_path__ + "img/cover-dark.f55e22cb.png";